import dayjs from 'dayjs';

export function dateFormat(date: string | null, dateOnly = false): string {
	return date ? dayjs(date).format(dateOnly ? 'DD MMM YYYY' : 'DD-MM-YYYY HH:mm A') : '';
}
